import OpenedImageAreaComum from "./OpenedImageAreaComum";

export default OpenedImageAreaComum;
